"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _slideLeft = require("@catalytic/catalytic-icons/lib/glyphs/slide-left.svg");
var _slideRight = require("@catalytic/catalytic-icons/lib/glyphs/slide-right.svg");
var _FilterSortItem = _interopRequireDefault(require("./FilterSortItem"));
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: (0, _defineProperty2.default)({}, theme.breakpoints.gte.tablet.portrait, {
      marginLeft: 'auto',
      marginRight: 0 // Override right margin so this is flush with the right boundary
    }),
    icon: {
      color: theme.colors.pebbleGrey,
      fontSize: '1.875rem',
      marginRight: '-0.375rem',
      padding: '0.375rem'
    }
  };
});
/*:: type Props = {
  isOpen: boolean,
  setIsOpen: boolean => void
};*/
var FilterSortSidebarOpener = function FilterSortSidebarOpener(props /*: Props*/) {
  var isOpen = props.isOpen,
    setIsOpen = props.setIsOpen;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_FilterSortItem.default, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, isOpen && /*#__PURE__*/_react.default.createElement(_slideRight.ReactComponent, {
    className: classes.icon,
    "data-testid": "sidebar-opener-slide-right"
  }), !isOpen && /*#__PURE__*/_react.default.createElement(_slideLeft.ReactComponent, {
    className: classes.icon,
    "data-testid": "sidebar-opener-slide-left"
  })));
};
FilterSortSidebarOpener.displayName = 'FilterSortSidebarOpener';
var _default = exports.default = FilterSortSidebarOpener;
//# sourceMappingURL=FilterSortSidebarOpener.js.map